import { render, staticRenderFns } from "./deadlines.vue?vue&type=template&id=34d95c37&"
import script from "./deadlines.vue?vue&type=script&lang=js&"
export * from "./deadlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports